export default "__VITE_ASSET__acbe9eb2__"